<template>
  <header class="app-header">
    <app-container class="app-header__container">
      <router-link to="/">
        <img
          class="app-header__logo"
          src="../../assets/logo.svg"
          alt="Logo MAXIMUM"
        >
      </router-link>
      <a
        class="phone"
        href="tel:88007755381"
      >
        <icon-phone class="phone__icon"/>
        <span class="phone__number">8-800-775-53-81</span>
      </a>
    </app-container>
  </header>
</template>

<script>
import AppContainer from '../Base/AppContainer';
import IconPhone from '../Icons/IconPhone';

export default {
  name: 'AppHeader',
  components: {
    AppContainer,
    IconPhone,
  },
};
</script>

<style lang="scss" scoped>
  .app-header {
    height: 64px;
    background: #fff;
    box-shadow: 0px 4px 14px rgba(70, 97, 138, 0.2);
    z-index: 10;
    flex-shrink: 0;

    &__container {
      display: flex;
      justify-content: space-between;
      height: 100%;
      align-items: center;
    }

    &__logo {
      height: 40px;
      width: 118px;
    }
  }

  .phone {
    display: flex;
    font-family: "Open Sans","sans-serif";
    font-size: 15px;
    font-weight: 400;
    color: #9f9f9f;
    text-decoration: none;
    justify-content: space-between;
    align-items: center;

    &__icon {
      margin-right: 8px;
    }
  }
</style>
